
<h1 *ngIf="name">{{ name }}</h1>

<div class="page-text" [innerHtml]="text"></div>